import * as fromEditActions from '../../../actions/AdmMapa/Eventos/ActiveEditor.actions';


export interface EditState {
    Operacion: string;
    Capa:string;
    Id_Capa:string;
    Id_Cambio_Capa:string;
    OperacionCambio:string;
}

const initialEditTool: EditState = {
    Operacion: '',
    Capa: '',
    Id_Capa: '',
    Id_Cambio_Capa: '',
    OperacionCambio: ''
};

export function EditorReducer(state = initialEditTool, action: fromEditActions.EditActions): EditState {
    switch (action.type) {
        case fromEditActions.ACTIVAR_EDIT:
            return {
                ...state,
                Operacion: action.Operacion,
                Capa: action.Capa,
                Id_Capa: '',
                Id_Cambio_Capa: '',
                OperacionCambio: ''
            };
        case fromEditActions.CANCELAR_EDIT:
            return {
                ...state,
                Operacion: '',
                Capa: '',
                Id_Capa: action.IdCapa,
                Id_Cambio_Capa : action.IdCambioCapa,
                OperacionCambio: action.OperacionCambio
            };
      default: {
        return state;
      }
    }
}